export const buildAiTaskStorageKey = (leadId, canvasId) =>
  `crm-ai-design-task:${leadId}:${canvasId || leadId}`;

export const resolveMediaUrl = (path, publicBaseUrl = '') => {
  if (typeof path !== 'string' || !path) return null;
  if (path.startsWith('http')) return path;
  const cleanPath = path.replace(/^\/?media\//, '');
  const base = String(publicBaseUrl)
    .replace(/\/imagery\/?$/, '/media')
    .replace(/\/$/, '');
  return base ? `${base}/${cleanPath}` : `/media/${cleanPath}`;
};

export const compactDroneAddress = (address = {}) => ({
  street: address.street,
  city: address.city,
  state: address.state,
  country: address.country,
  zipcode: address.zipcode,
  formatted: address.formatted
});

export const compactDroneProject = (payload = {}) => ({
  projectId: payload.projectId,
  hostLeadId: payload.hostLeadId,
  companyId: payload.companyId,
  projectName: payload.projectName,
  projectType: payload.projectType,
  leadType: payload.leadType,
  lat: payload.lat,
  long: payload.long,
  address: compactDroneAddress(payload.address || {}),
  orthoTicketId: payload.orthoTicketId,
  sourcePlyTicketId: payload.sourcePlyTicketId,
  rgbOutputId: payload.rgbOutputId,
  dsmOutputId: payload.dsmOutputId
});

export const parseDatasetKeyFromPath = (path) => {
  try {
    if (!path || typeof path !== 'string') return null;
    const base = path.split('/').pop() || '';
    if (!base.endsWith('.csv')) return null;
    return base.slice(0, -'.csv'.length) || null;
  } catch {
    return null;
  }
};
